import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import CeklistProsedurInvasifSvc from "@/services/CeklistProsedurInvasif";

@Module({ store, dynamic: true, namespaced: true, name: "ceklist-prosedur-invasif" })
class CeklistProsedurInvasifModule extends VuexModule {
  list: any[] = [];
  loading = false;

  @Mutation SET_LIST(val: any[]) {
    this.list = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await CeklistProsedurInvasifSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_LIST(data || []);
    } catch {
      this.SET_LIST([]);
    }

    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await CeklistProsedurInvasifSvc.find(id);
      const { data } = dt.data;
      const idx = this.list.findIndex(item => item.id === id);
      if (idx >= 0) {
        const newList = [...this.list];
        newList[idx] = data;
        this.SET_LIST(newList);
      }
    } catch {
      // ignore
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_LIST([]);
  }
}

export const storeCeklistProsedurInvasif = getModule(CeklistProsedurInvasifModule);
